import { React } from 'react';

export const Loader = () => {
    return (
        <div className="preloader-content">
            <i className="preloader circle-preloader"></i>
        </div>
    )
}